import script from "./CustomResourceApplySW.vue?vue&type=script&setup=true&lang=ts"
export * from "./CustomResourceApplySW.vue?vue&type=script&setup=true&lang=ts"

import "./CustomResourceApplySW.vue?vue&type=style&index=0&id=9df212b6&lang=less&scope=true"

const __exports__ = script;

export default __exports__